import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/admin/reglages` opens on the models (BUILD-851).
 *
 * A redirection rather than a landing page listing four links: the layout
 * already shows the four sub-tabs, so a page whose only content is those same
 * four names costs a click and says nothing. The models are first because they
 * are the setting that gets moved most often, and because the maquette opens
 * this screen on them.
 *
 * Precedent and régime: `/admin/index.tsx`, and the three redirections of S4.
 */

export const Route = createFileRoute('/admin/reglages/')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/reglages/modeles' });
  },
});
